import { Modal, ModalProps } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { DownloadAsXRechnungModalBody } from './elements/DownloadAsXRechnungModalBody'
import { DownloadAsXRechnungModalFooter } from './elements/DownloadAsXRechnungModalFooter'

type DownloadAsXRechnungModalComponentProps = ModalProps

export const DownloadAsXRechnungModalComponent = ({
  ...modalProps
}: DownloadAsXRechnungModalComponentProps): ReactElement => {
  const { t } = useTranslation()

  return (
    <Modal {...modalProps} size="s">
      <Modal.Header title={t('external_invoices.download_as_xrechnung.modal.title')} />
      <DownloadAsXRechnungModalBody />
      <DownloadAsXRechnungModalFooter id={modalProps.id} />
    </Modal>
  )
}
